import { DEVICE_TYPE } from "src/module/const";

const kzs = window.kzs;
const $ = kzs.$;

export const setGoals = (isOriginal: boolean): void => {
  const deviveType = kzs.navigator.getDeviceType();

  // 1st Viewカルーセル内コンテンツ
  $(document).one("click", ".l-mainvisual .slick-slide a", () => {
    kzs("trackClickGoals", 45748);
  });

  // カルーセルインジケーターのクリック数
  $(document).one("click", ".l-mainvisual .slick-dots button", () => {
    kzs("trackClickGoals", 45749);
  });

  if (!isOriginal) {
    // 「過去に閲覧した車種」クリック数
    $(document).one("click", ".kz-history a", () => {
      kzs("trackClickGoals", 45750);
    });

    // 見積もり結果施策
    $(document).on("click", ".kz-car-reserve--button", () => {
      kzs("trackClickGoals", 47695);
    });
  }

  // CTAフローティング整理
  const targetClass =
    deviveType == DEVICE_TYPE.sp ? ".trac_menu" : isOriginal ? "#side_cv" : ".kz-cta-btn-wrap--floating";

  $(document).on("click", targetClass + " a[href^='https://members.subaru.jp/estimate_simulation/']", () => {
    kzs("trackClickGoals", 47212);
  });
  $(document).on("click", targetClass + " a[href^='https://ap.subaru.jp/search/drivecar']", () => {
    kzs("trackClickGoals", 47214);
  });

  if (isOriginal) {
    $(document).on("click", targetClass + " a[href^='https://ec.subaru.jp/online-meeting/']", () => {
      kzs("trackClickGoals", 47213);
    });
    $(document).on("click", targetClass + " a[href^='https://ap.subaru.jp/search/dealer']", () => {
      kzs("trackClickGoals", 47215);
    });
    $(document).on(
      "click",
      targetClass +
        " a[href^='" +
        (deviveType == DEVICE_TYPE.sp
          ? "https://members.subaru.jp/smp/catalog/"
          : "https://members.subaru.jp/catalog/catalog_apply") +
        "']",
      () => {
        kzs("trackClickGoals", 47216);
      }
    );
    $(document).on(
      "click",
      targetClass +
        " a[href^='" +
        (deviveType == DEVICE_TYPE.sp ? "https://www.subaru.jp/faq/" : "https://faq.subaru.jp/") +
        "']",
      () => {
        kzs("trackClickGoals", 47217);
      }
    );
  } else {
    $(document).on(
      "click",
      targetClass + " a[href^='https://" + (deviveType == DEVICE_TYPE.sp ? "sp" : "www") + ".subaru.jp/carlineup/']",
      () => {
        kzs("trackClickGoals", 47218);
      }
    );
  }
};
